import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getNotification } from '../Service/Api';

const Notification = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getNotification();
      console.log(response);
      setData(response);

      // Show the modal if data is available
      if (response && response.length > 0) {
        setShowModal(true);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (showModal) {
      const modalElement = document.getElementById("exampleModalToggle");
      if (modalElement) {
        // Initialize and show the modal using Bootstrap JS
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }, [showModal]);

  const handleHideModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {data.length > 0 && showModal && (
        <div
          className="popup modal fade show"
          id="exampleModalToggle"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
          aria-hidden="false"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              {/* Modal Header: Title and Close Button */}
              

              {/* Modal Body: Main Content (Image, Description) */}
              <div className="modal-body p-0">
                <div id="modalH" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {data.map((item, index) => (
                      <div
                        key={index}
                        className={`carousel-item ${index === 0 ? 'active' : ''}`}
                      >
                        <div className="modal-header">
                <h5 className="modal-title" id="exampleModalToggleLabel">
                  {item.title || "Notification"} {/* Title from data */}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleHideModal}
                ></button>
              </div>
                        <div className="card modalcard p-2">
                          <div className="">
                            <div className="card-body p-0">
                              {/* Conditionally render image */}
                              {item.image && item.image.length > 0 && (
                                <img
                                  src={`https://webapi.entab.info/api/image/${item.image[0]}`}
                                  className="img-fluid "
                                  alt="Notification"
                                />
                              )}
                              <p className='m-0'>{item.description}</p>
                            </div>
                          </div>
                        </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-center p-0 m-2">
                {/* Conditionally render attachment link */}
                {item.attachments.length > 0 && (
                  <Link
                    target="_blank"
                    to={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
                    className="btn  btn-secondary btn-sm" 
                  >
                    Attachment
                  </Link>
                )}

                {/* Conditionally render "Click Here" link */}
                {item.url && (
                  <Link
                    target="_blank"
                    to={item[0]?.url}
                    className="btn  btn-secondary btn-sm"
                  >
                    Click Here
                  </Link>
                )}
              </div>
                      </div>
                    ))}
                  </div>

                  {/* Carousel Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#modalH"
                    data-bs-slide="prev"
                  >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#modalH"
                    data-bs-slide="next"
                  >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>

              {/* Modal Footer: Action Buttons */}
              
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Notification;
